import { useEffect, useState } from 'react';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import '@/App.css';
import { Toaster } from '@/components/ui/sonner';
import Cursor from '@/components/Cursor';
import Nav from '@/components/Nav';
import Hero from '@/components/Hero';
import Marquee from '@/components/Marquee';
import About from '@/components/About';
import Services from '@/components/Services';
import Process from '@/components/Process';
import Social from '@/components/Social';
import Enquiry from '@/components/Enquiry';
import Footer from '@/components/Footer';

export default function App() {
  const [lenis, setLenis] = useState(null);

  useEffect(() => {
    const instance = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      instance.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    setLenis(instance);
    return () => {
      cancelAnimationFrame(raf);
      instance.destroy();
    };
  }, []);

  const scrollTo = (target) => {
    if (lenis) {
      lenis.scrollTo(target, { offset: -72, duration: 1.4 });
    } else {
      document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-[#155533] text-[#FCFBFA]" data-testid="app-root">
      <div className="grain-overlay" aria-hidden="true" />
      <Cursor />
      <Nav onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <Marquee />
        <About />
        <Services />
        <Process />
        <Social />
        <Enquiry />
      </main>
      <Footer onNavigate={scrollTo} />
      <Toaster position="bottom-right" theme="dark" richColors toastOptions={{ style: { background: '#207347', border: '1px solid rgba(220,188,127,0.3)', color: '#FCFBFA' } }} />
    </div>
  );
}
